/**
 * Responsável por desenhar os markers na tela de detalhe da rota
 * Created by adalto on 5/8/14.
 */

import {
  getStopStatus,
  STOP_STATUS,
  getStopStatusResourceByStatus,
  STOP_TOOLTIP_CONFIG,
  formatNextStopMessageTooltip
} from 'react/utils/stopUtils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.MarkerStop = function (map, routeId) {
    this.points = [];
    this.onStopClick = null;
    this.baseColor = null;
    this.drawStopsGeocode = true;
    this.fitToBounds = false;
    this.clearBeforeDraw = true;

    this.setDrawGeocode = (drawStopsGeocode) => {
      this.drawStopsGeocode = drawStopsGeocode;
    };

    this.setFitToBounds = (fitToBounds) => {
      this.fitBounds = fitToBounds;
    };

    const drawStopGeocode = (stop, stopNumber) => {
      const geocodeStop = new Greenmile.RouteDetail.GeocodeStop(routeId, map);
      const {
        latitude,
        longitude,
        location: {
          latitude: locationLatitude,
          longitude: locationLongitude
        }
      } = stop;


      if (locationLatitude && locationLongitude && (locationLatitude !== latitude && locationLongitude !== longitude)) {
        geocodeStop
          .setCorrectLocation(locationLatitude, locationLongitude)
          .setStop(stop)
          .createMarker(stopNumber)
          .addTo(map);
        geocodeStop.drawPolyline([latitude, longitude], [locationLatitude, locationLongitude]);
      }
    };

    const showIconOriginDestination = function (route) {
      const originIcon = require("static/images/map/markers/origin_location.png");
      const destinationIcon = require("static/images/map/markers/destination.png");
      let marker = null;

      if (route.origLatitude && route.origLongitude) {
        marker = L.marker([route.origLatitude, route.origLongitude], {
          icon: new L.Icon({
            iconUrl: originIcon,
            iconSize: [18, 18]
          })
        });

        if (route.origin) {
          marker.id = route.origin.id;
        }

        marker.kind = "STOP";
        marker.addTo(map);
      } else {
        console.log("Origin route( id : " + route.id + ") without latitude and longitude");
      }

      if (route.destLatitude && route.destLongitude) {
        marker = L.marker([route.destLatitude,
          route.destLongitude], {
          icon: new L.Icon({
              iconUrl: destinationIcon,
              iconSize: [18, 18]
          })
        });

        if (route.destination) {
          marker.id = route.destination.id;
        }

        marker.kind = "STOP";
        marker.addTo(map);
      } else {
        console.log("Destination route( id : " + route.id + ") without latitude and longitude");
      }
    };

    const onStopClick = (stop) => {
      if (!this.onStopClick) {
        const stopSelection = new Greenmile.RouteDetail.StopSelection(routeId);
        stopSelection.selectOrDeselectStop(stop.id);

        return;
      }

      this.onStopClick(stop);
    };

    const drawNextStopMarker = (latitude, longitude, stop) => {
      Greenmile.Map.Utility.removeLayerByKind(map, ['NEXT_STOP_LAYER']);

      const nextStopIcon = L.divIcon({ className: 'iconNextStop iconNextStopOnRouteDetails' });
      const nextStopMarker = L.marker([latitude, longitude], { icon: nextStopIcon });

      nextStopMarker.kind = 'NEXT_STOP_LAYER';
      nextStopMarker.nextStop = stop.projectedArrival;
      nextStopMarker
        .addTo(map)
        .bindTooltip(formatNextStopMessageTooltip(stop.projectedArrival), STOP_TOOLTIP_CONFIG)
        .on('mouseover', () => nextStopMarker.openTooltip())
        .on('mouseout', () => nextStopMarker.closeTooltip());
    };

    const handleMarkerEvents = (marker, stop) => {
      let tooltipText = Monet.I18n.getResourcesByKey(
        getStopStatusResourceByStatus(
          getStopStatus(stop)
        )
      );
      if (stop.confirmedAsNextStop && getStopStatus(stop) !== STOP_STATUS.PENDING) {
        marker.nextStop = stop.projectedArrival;
        tooltipText = formatNextStopMessageTooltip(stop.projectedArrival);
        marker
          .bindTooltip(tooltipText, STOP_TOOLTIP_CONFIG)
          .on('mouseover', () => marker.openTooltip())
          .on('mouseout', () => marker.closeTooltip());
      }
      marker
        .bindTooltip(tooltipText, STOP_TOOLTIP_CONFIG)
        .on('click', () => onStopClick(stop))
        .on('mouseover', () => marker.openTooltip())
        .on('mouseout', () => marker.closeTooltip());
    };

    const drawStopMarker = (stop, iconOptions) => {
      const {
        latitude,
        longitude,
        deliveryStatus,
        projectedArrival,
        confirmedAsNextStop
       } = stop;

      if (latitude && longitude) {
        const marker = L.marker([latitude, longitude], {
          icon: new Greenmile.RouteDetail.NumberedDivIcon(iconOptions),
          draggable: false,
          riseOnHover: true
        });

        marker.id = stop.id;
        marker.kind = "STOP";

        if (marker._latlng.lat && marker._latlng.lng) {
          if (confirmedAsNextStop && projectedArrival && deliveryStatus === STOP_STATUS.PENDING) {
            Greenmile.Map.Utility.removeLayerByKind(map, ['NEXT_STOP_LAYER']);

            const nextStopIcon = L.divIcon({ className: 'iconNextStop iconNextStopOnRouteDetails' });
            const nextStopMarker = L.marker([latitude, longitude], { icon: nextStopIcon });

            nextStopMarker.kind = 'NEXT_STOP_LAYER';
            nextStopMarker.nextStop = stop.projectedArrival;
            nextStopMarker.addTo(map)
              .on('mouseover', Greenmile.Stop.Util.showNextStopTooltip)
              .on('mouseout', Greenmile.Stop.Util.hideNextStopTooltip);
          }

          marker.addTo(map);

          if (stop.confirmedAsNextStop){
            marker.nextStop = stop.projectedArrival;
            marker
              .on("mouseover", Greenmile.Stop.Util.showNextStopTooltip)
              .on('mouseout', Greenmile.Stop.Util.hideNextStopTooltip);
          }

          marker.on("click", () => onStopClick(stop));

          if (this.drawStopsGeocode) {
            drawStopGeocode(stop, iconOptions.content);
          }

        } else {
          console.log("STOP(" + marker.id + ") without latitude and longitude.");
        }
      } else {
        console.log("STOP(" + stop.id + ") without latitude and longitude.");
        return;
      }

      const marker = L.marker([latitude, longitude], {
        icon: new Greenmile.RouteDetail.NumberedDivIcon(iconOptions),
        draggable: false,
        riseOnHover: true
      });

      marker.id = stop.id;
      marker.kind = "STOP";

      if (!(marker._latlng.lat && marker._latlng.lng)) {
        console.log("STOP(" + marker.id + ") without latitude and longitude.");
        return;
      }

      if (stop.confirmedAsNextStop && stop.projectedArrival) {
        drawNextStopMarker(latitude, longitude, stop);
      }

      marker.addTo(map);

      handleMarkerEvents(marker, stop);

      if (this.drawStopsGeocode) {
        drawStopGeocode(stop, iconOptions.content);
      }
    };

    this.getStopMarkerBorderColor = (stop) => {
      const { deliveryStatus } = stop;

      if (deliveryStatus === STOP_STATUS.PENDING) {
        return this.baseColor ?? 'var(--stop-marker-purple)';
      }

      return null;
    };

    this.getStopMarkerColor = (stop) => {
      const {
        latitude,
        longitude,
        location,
        deliveryStatus
       } = stop;

      const locationLatitude = location?.latitude;
      const locationLongitude = location?.longitude;

      if ((!latitude && !longitude && locationLatitude && locationLongitude)) {
        return 'blue';
      }

      if (deliveryStatus === 'PENDING') {
        return 'var(--grey-400)';
      }

      return this.baseColor ?? 'var(--stop-marker-purple)';
    };

    this.fitBoundsToStopsCoords = () => {
      if (!this.fitBounds) return;

      if (this.points.length > 0) {
        map.fitBounds(this.points);
      } else {
        const error = new Monet.Exception.ReturnError(this, "No points to show on map.");
        error.console();
      }
    };

    this.updateStopPoints = (stop) => {
      const {
        latitude,
        longitude,
        location
       } = stop;

      const locationLatitude = location?.latitude;
      const locationLongitude = location?.longitude;

      if (latitude && longitude) {
        this.points.push([latitude, longitude]);
      } else if (!latitude && !longitude && locationLatitude && locationLongitude) {
        this.points.push([locationLatitude, locationLongitude]);
      } else {
        console.log("STOP(" + stop.id + ") without latitude and longitude.");
      }
    }

    this.drawStopsMarkers = function (stops, callback) {
      const stopsLength = stops.size();

      if (stopsLength) {
        const route = stops.at(0).get('route');

        const hasPro = !!route.proactiveRouteOptConfig;

        for (let i = 0, j = stopsLength; i < j; i++) {
          const stop = stops.at(i).get('stop');

          const {
            plannedSequenceNum,
            actualSequenceNum,
            redeliveryStop,
            location,
            latitude,
            longitude
          } = stop;


          const locationLatitude = location?.latitude;
          const locationLongitude = location?.longitude;

          const plot = !redeliveryStop?.id;

          let labelText = `<strong>${plannedSequenceNum}</strong>`;

          if (actualSequenceNum && !hasPro) {
            labelText = labelText.concat(`<p>/${actualSequenceNum}</p>`)
          }

          const iconOptions = {
            color: this.getStopMarkerColor(stop),
            borderColor: this.getStopMarkerBorderColor(stop),
            content: labelText,
            plot: plot,
            statusClass: getStopStatus(stop),
            testId: `stop-marker-${stop.id}`
          };

          if (!latitude && !longitude && locationLatitude && locationLongitude) {
            const stopWithLocationLatLng = {
              ...stop,
              latitude: locationLatitude,
              longitude: locationLongitude,
            }

            drawStopMarker(stopWithLocationLatLng, iconOptions);
          } else {
            drawStopMarker(stop, iconOptions);
          }

          this.updateStopPoints(stop);
        }

        if (route) {
          showIconOriginDestination(route);
        }

        if (this.fitToBounds) {
          this.fitBoundsToStopsCoords();
        }

        callback?.(stops);
      }
    };

    this.removeStopsFromMap = function () {
      for (let i in map._layers) {
        const layer = map._layers[i];
        if (layer.kind === 'STOP' || layer.kind === 'POLYLINE_STOP') {
          map.removeLayer(layer);
        }
      }
    };

    this.checkAndDrawStops = function (collection, callback) {
      const storage = new Greenmile.Storage.StoreMapPosition();
      const mapPreferences = storage.getLayerMapFromUser();

      if (Monet.Session.RouteDetail?.screensList?.[routeId]) {
        Monet.Session.RouteDetail.screensList[routeId].markerStops = collection;
      }

      if (this.clearBeforeDraw) this.removeStopsFromMap();

      if (mapPreferences.stops) {
        this.drawStopsMarkers(collection, callback);
      } else if (callback) {
        callback(collection);
      }
    };

    this.getStopsAndDrawOnMap = function (context) {

        return function (callback) {

            const projectionBuilder = new Monet.Builder.Projection();
            const stopView = new App.Collections.StopViews();

            projectionBuilder.addFields([
                { name: "*" },
                { name: "stop.*" },
                { name: "stop.location.*" },
                { name: "stop.location.locationType.*" },
                { name: "stop.stopType.*" },
                { name: "stop.cancelCode.*" },
                { name: "stop.redeliveryStop.*" },
                { name: "stop.redeliveryStop.location.key*" },
                { name: "stop.undeliverableCode.*" },
                { name: "route.origLatitude" },
                { name: "route.origLongitude" },
                { name: "route.destLatitude" },
                { name: "route.destLongitude" },
                { name: "route.origin.*" },
                { name: "route.destination.*" },
                { name: "route.organization.id" },
                { name: "route.proactiveRouteOptConfig" },
            ]);

            const filter = {
                "criteriaChain": [{
                    "and": [{
                        "attr": "route.id",
                        "eq": routeId
                    }]
                }],
                "sort": [{
                    "attr": "stop.plannedSequenceNum",
                    "type": "ASC"
                }
                ]
            };

            projectionBuilder.addFieldsToIncluding(['geofence']);
            stopView.filterWithRestrictions({
                filter: filter,
                criteria: projectionBuilder.projection.toString(),
                success: function (collection) {

                  if (collection.size()) {
                    const organizationId = collection.first().get("route").organization.id;

                    let ajax = new Monet.Ajax();
                    ajax.url = 'Configuration/restrictions?criteria={"filters":["id","locationsVisitRadiusMeters","organization.id"],"firstResult":0,"maxResults":51}';
                    ajax.method = 'POST';
                    ajax.data = `{"criteriaChain":[{"and":[{"attr":"organization.id","eq":${organizationId}}]}]}`;
                    ajax.success = (data) => {
                      if (data && data[0]) {
                        const organizationRadius = data[0].locationsVisitRadiusMeters || null;
                        Monet.Session.Configurations.organizationRadius = organizationRadius;
                      }
                      context.checkAndDrawStops(collection, callback);
                    };
                    ajax.send();
                  } else {
                    context.checkAndDrawStops(collection, callback);
                  }
                }
            });

        };

    }(this);

    this.closePopup = () => {
        const stopSelection = new Greenmile.RouteDetail.StopSelection(routeId);
        stopSelection.deselectStop();
    };
};
